
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import CategoryFilterGroup from "./CategoryFilterGroup.vue";
import { OrganizationFilterStore } from "../../stores/organization/OrganizationFilterStore";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";

@Component({
    components: { CategoryFilterGroup },
})
export default class CountryFilter extends Vue {
    @Inject("container") container!: Container;
    readonly organizationListStore: OrganizationListStore =
        this.container.get(OrganizationListStore);
    readonly organizationFilterStore: OrganizationFilterStore =
        this.container.get(OrganizationFilterStore);

    get countries(): string[] {
        if (this.organizationListStore.items) {
            return [
                ...new Set(
                    this.organizationListStore.items
                        .filter((item) => item.country)
                        .map((item) => item.country || "")
                        .sort(),
                ),
            ];
        } else {
            return [];
        }
    }
}
